import React, { useState, useEffect } from 'react';
import { useUser } from '../context/UserContext';
import Select from 'react-select';

const SelectBoxResponsavelPesquisa = ({ value, onChange }) => {
  const { loadUserOptions } = useUser();
  const [ usersLoaded, setUsersLoaded ] = useState([]);
  const [ responsavelSelecionadoPesquisa, setResponsavelSelecionadoPesquisa ] = useState('');

  useEffect(() => {
    loadUserOptions()
      .then(setUsersLoaded)
      .catch(err => console.error('Erro ao buscar opções de usuários:', err));

      loadUserOptions();
  }, [responsavelSelecionadoPesquisa, setResponsavelSelecionadoPesquisa]);

  // Transforma a lista de usuários em formato compatível com react-select
  const options = usersLoaded.map(user => ({
    value: user.id,
    label: user.nome
  }));

  // Converte o valor atual em objeto para manter o controle visual
  const selectedOption = options.find(option => option.value === value) || null;

  const handleChange = selected => {
    onChange(selected ? selected.value : '');
    setResponsavelSelecionadoPesquisa(selected ? selected.value : '');
  };

  return (
    <div style={{ width: 300 }}>
      <div className="periodo-selecionado">
        <label htmlFor="select-box" style={{ display: 'block', marginBottom: 8 }}>
            Selecione um responsável:
        </label>
      </div>
      <Select
        inputId="select-box"
        value={selectedOption}
        onChange={handleChange}
        options={options}
        placeholder="Selecione..."
        isClearable
        styles={{
          control: (base) => ({
            ...base,
            borderColor: '#ccc',
            boxShadow: 'none',
            '&:hover': { borderColor: '#007bff' }
          })
        }}
      />
    </div>
  );
};


export default SelectBoxResponsavelPesquisa;